import Dome from './dome'
import User from './user'
import Operation from './operation'
import Correcting from './correcting'

export default {
  ...Dome,               // dome 类
  ...Operation,          // Operation 类
  ...Correcting,         // 试卷类
  ...User                // User 类
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/index.js